import React from 'react'

// reactstrap components
import {
  Pagination as ReactPagination,
  PaginationItem,
  PaginationLink
} from "reactstrap"

function Pagination (props) {

  const DEFAULT_LIMIT = 10
  const DEFAULT_DISPLAY_MAX_PAGES = 5

  const { page, pages, count, onChangePage } = props
  const totalPages = Math.max(
    0,
    pages !== undefined ? Number(pages) : Math.ceil((Number(count) || 0) / DEFAULT_LIMIT)
  )
  const halfWindow = Math.floor(DEFAULT_DISPLAY_MAX_PAGES / 2)
  const firstPage = Math.max(
    1,
    Math.min(page - halfWindow, totalPages - DEFAULT_DISPLAY_MAX_PAGES + 1)
  )
  const lastPage = Math.min(totalPages, firstPage + DEFAULT_DISPLAY_MAX_PAGES - 1)
  const pagesToDisplay = Array.from(
    { length: Math.max(0, lastPage - firstPage + 1) },
    (_, index) => firstPage + index
  )

  const changePage = (newPage) => {
    if (newPage === page) return
    if (newPage > totalPages || newPage < 1) {
      return
    }
    return (
      onChangePage(newPage)
    )
  }

  return (
    <>
      <nav aria-label="...">
        <ReactPagination
          className="pagination justify-content-end mb-0"
          listClassName="justify-content-end mb-0"
        >
          <PaginationItem disabled={page <= 1}>
            <PaginationLink
              className='pagination--link'
              onClick={() => changePage(page - 1)}
              disabled={page <= 1}
              tabIndex="-1"
            >
              <i className="fas fa-angle-left" />
              <span className="sr-only">Previous</span>
            </PaginationLink>
          </PaginationItem>
          {
            pagesToDisplay.map(p => (
              <PaginationItem key={p} className={'pagination--item ' + (page === p ? "active" : null)}>
                <PaginationLink
                  className='pagination--link'
                  onClick={() => changePage(p)}
                >
                  { p }
                </PaginationLink>
              </PaginationItem>
            ))
          }
          <PaginationItem className='pagination--item' disabled={page >= totalPages}>
            <PaginationLink
              className='pagination--link'
              disabled={page >= totalPages}
              onClick={() => changePage(page + 1) }
            >
              <i className="fas fa-angle-right" />
              <span className="sr-only">Next</span>
            </PaginationLink>
          </PaginationItem>
        </ReactPagination>
      </nav>
    </>
  )
}

export default Pagination